let is_empty = function(...arr) {
	arr = arr.map(e => {
		return ((e == '') || (e == undefined) || (e == null))
	})
	console.log(arr)
	return arr.some(e => e)
}

export {
	is_empty
}



// WEBPACK FOOTER //
// ./src/js/examine.js